import { Reducer } from 'redux';
import {
    SALES_DASHBOARD_ERROR,
    SALES_DASHBOARD_CLEAR_ERROR,
    SALES_DASHBOARD_KPI_SUMMARY_FETCH_START,
    SALES_DASHBOARD_KPI_SUMMARY_FETCH_SUCCESS,
    SALES_DASHBOARD_SALES_ATTRIBUTION_FETCH_START,
    SALES_DASHBOARD_SALES_ATTRIBUTION_FETCH_SUCCESS,
    SALES_DASHBOARD_TOP_ITEMS_FETCH_START,
    SALES_DASHBOARD_TOP_ITEMS_FETCH_SUCCESS,
    SALES_DASHBOARD_ADJUSTMENTS_FETCH_START,
    SALES_DASHBOARD_ADJUSTMENTS_FETCH_SUCCESS,
    SALES_DASHBOARD_LEADERBOARD_FETCH_START,
    SALES_DASHBOARD_LEADERBOARD_FETCH_SUCCESS,
    SALES_DASHBOARD_UPDATE_FILTERS,
    SalesDashboardAction
} from 'actions/salesDashboard/SalesDashboardActionsTypes';
import { SalesDashboardState, SalesDashboardStatus } from './SalesDashboardState';
import moment from 'moment-timezone';

const initialState: SalesDashboardState = {
    status: SalesDashboardStatus.Initial,
    loadingKpiSummary: false,
    loadingSalesAttribution: false,
    loadingTopItems: false,
    loadingAdjustments: false,
    loadingLeaderboard: false,
    filters: {
        startDate: moment().startOf('year'),
        endDate: moment(),
        compareStartDate: moment().subtract(1, 'year').startOf('year'),
        compareEndDate: moment().subtract(1, 'year')
    }
};

export const salesDashboardReducer: Reducer<SalesDashboardState, SalesDashboardAction> = (
    state = initialState,
    action
) => {
    switch (action.type) {
        case SALES_DASHBOARD_ERROR:
            return {
                ...state,
                status: SalesDashboardStatus.Error,
                error: action.payload.error,
                loadingKpiSummary: false,
                loadingSalesAttribution: false,
                loadingTopItems: false,
                loadingAdjustments: false,
                loadingLeaderboard: false
            };

        case SALES_DASHBOARD_CLEAR_ERROR:
            return {
                ...state,
                status: SalesDashboardStatus.Initial,
                error: undefined
            };

        case SALES_DASHBOARD_KPI_SUMMARY_FETCH_START:
            return {
                ...state,
                status: SalesDashboardStatus.Fetching,
                loadingKpiSummary: true
            };

        case SALES_DASHBOARD_KPI_SUMMARY_FETCH_SUCCESS:
            return {
                ...state,
                status: SalesDashboardStatus.FetchSuccess,
                loadingKpiSummary: false,
                kpiSummary: action.payload.kpiSummary
            };

        case SALES_DASHBOARD_SALES_ATTRIBUTION_FETCH_START:
            return {
                ...state,
                status: SalesDashboardStatus.Fetching,
                loadingSalesAttribution: true
            };

        case SALES_DASHBOARD_SALES_ATTRIBUTION_FETCH_SUCCESS:
            return {
                ...state,
                status: SalesDashboardStatus.FetchSuccess,
                loadingSalesAttribution: false,
                salesAttribution: action.payload.salesAttribution
            };

        case SALES_DASHBOARD_TOP_ITEMS_FETCH_START:
            return {
                ...state,
                status: SalesDashboardStatus.Fetching,
                loadingTopItems: true
            };

        case SALES_DASHBOARD_TOP_ITEMS_FETCH_SUCCESS:
            return {
                ...state,
                status: SalesDashboardStatus.FetchSuccess,
                loadingTopItems: false,
                topItems: action.payload.topItems
            };

        case SALES_DASHBOARD_ADJUSTMENTS_FETCH_START:
            return {
                ...state,
                status: SalesDashboardStatus.Fetching,
                loadingAdjustments: true
            };

        case SALES_DASHBOARD_ADJUSTMENTS_FETCH_SUCCESS:
            return {
                ...state,
                status: SalesDashboardStatus.FetchSuccess,
                loadingAdjustments: false,
                adjustments: action.payload.adjustments
            };

        case SALES_DASHBOARD_LEADERBOARD_FETCH_START:
            return {
                ...state,
                status: SalesDashboardStatus.Fetching,
                loadingLeaderboard: true
            };

        case SALES_DASHBOARD_LEADERBOARD_FETCH_SUCCESS:
            return {
                ...state,
                status: SalesDashboardStatus.FetchSuccess,
                loadingLeaderboard: false,
                leaderboard: action.payload.leaderboard
            };

        case SALES_DASHBOARD_UPDATE_FILTERS:
            return {
                ...state,
                filters: {
                    ...state.filters,
                    ...action.payload.filters
                }
            };

        default:
            return state;
    }
};

export default salesDashboardReducer;
